export function stickySharing() {

    function sticky() {
        if (window.innerWidth >= 1200) {
            let content = document.querySelector('.article-holder');
            let wrapPos = {};
            let fixedElement = content.querySelector('.social-sharing');
            let fixedItemInner = fixedElement.querySelector('.inner');
            let fixedItemHeight = parseInt(getComputedStyle(fixedItemInner, null).getPropertyValue('height'));
            wrapPos = content.getBoundingClientRect();
            if (wrapPos.top <= 150) {
                fixedElement.classList.add('sticky');
            } else {
                fixedElement.classList.remove('sticky');
            }
            if (wrapPos.bottom <= fixedItemHeight + 150) {
                fixedElement.classList.add('bottom-pos');
            } else {
                fixedElement.classList.remove('bottom-pos');
            }

        }
    }

    window.addEventListener("scroll", () => {
        sticky();
    });
    window.addEventListener("load", () => {
        sticky();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/stickySharing.js